import { render } from "./SingleComment.vue?vue&type=template&id=168d9150&scoped=true"
import script from "./SingleComment.vue?vue&type=script&lang=js"
export * from "./SingleComment.vue?vue&type=script&lang=js"

import "./SingleComment.vue?vue&type=style&index=0&id=168d9150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168d9150"]])

export default __exports__